import { useContext } from "react"
import * as React from "react"
import { Context } from "../../../store/store"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	formElementChanged: Function
	validation: Object
}
const MafoQuestionOne: React.FC<MafoQuestionProps> = ({ formElementChanged, validation }) => {
	const { globalState } = useContext(Context)
	return (
		<>
			<h3 className="font-Alpro mb-2 text-center text-[24px] text-blue lg:text-center lg:text-[32px]">Wie alt bist Du?*</h3>
			<p className="mb-4 text-center">Bitte wähle Deine Altersgruppe aus</p>
			<div className="mx-auto grid grid-cols-1 flex-row text-left md:grid-cols-3 lg:max-w-[75%]">
				<ElemCheckboxMafo
					label={<>18-29</>}
					props={{
						type: "radio",
						name: "question1",
						required: true,
						value: "a",
						onClick: e => formElementChanged(e, "question1"),
					}}
					className=" question1 pb-2 "
				/>
				<ElemCheckboxMafo
					label={<>30-39</>}
					props={{
						type: "radio",
						name: "question1",
						required: true,
						value: "b",
						onClick: e => formElementChanged(e, "question1"),
					}}
					className=" question1 pb-2 "
				/>
				<ElemCheckboxMafo
					label={<>40-49</>}
					props={{
						type: "radio",
						name: "question1",
						required: true,
						value: "c",
						onClick: e => formElementChanged(e, "question1"),
					}}
					className=" question1 pb-2 "
				/>
				<ElemCheckboxMafo
					label={<>50-59</>}
					props={{
						type: "radio",
						name: "question1",
						required: true,
						value: "d",
						onClick: e => formElementChanged(e, "question1"),
					}}
					className=" question1 pb-2 "
				/>
				<ElemCheckboxMafo
					label={<>60-69</>}
					props={{
						type: "radio",
						name: "question1",
						required: true,
						value: "e",
						onClick: e => formElementChanged(e, "question1"),
					}}
					className=" question1 pb-2"
				/>
				<ElemCheckboxMafo
					label={<>70+</>}
					props={{
						type: "radio",
						name: "question1",
						required: true,
						value: "f",
						onClick: e => formElementChanged(e, "question1"),
					}}
					className=" question1 "
				/>
			</div>
		</>
	)
}

export default MafoQuestionOne
